import React from "react";
import "./values.css";

function Values() {
  return (
    <>
      <h1 className="values-header-main fade-in-reviews">Our Values</h1>
      <div className="values-container">
        <div className="values-box fade-in-reviews">
          <h1 className="values-header">EMPATHY</h1>
          <p>
            We lead with understanding and treat every pup with genuine care.
          </p>
        </div>
        <div className="values-box fade-in-reviews">
          <h1 className="values-header">TRUST</h1>
          <p>
            We show up consistently, communicate clearly, and deliver on our
            promises.
          </p>
        </div>
        <div className="values-box fade-in-reviews">
          <h1 className="values-header">FLEXIBILITY</h1>
          <p>We adapt quickly and find solutions that fit real life.</p>
        </div>
        <div className="values-box fade-in-reviews">
          <h1 className="values-header">TRANSPARENCY</h1>
          <p>
            We keep everything clear, open, and honest. No hidden surprises.
          </p>
        </div>
      </div>
    </>
  );
}

export default Values;
